import React from "react";
import "./UserNeedsBadges.scss"

type UserNeedsObject = {
    emotion_driven : boolean,
    context_driven : boolean,
    fact_driven : boolean,
    action_driven : boolean
}

type UserNeedsBadgesProps = {
    userNeedsObj : UserNeedsObject,
    onSingleStory? : boolean 
}

const UNBadge = ({children} : {children : string}) => {
    return <div className="un-badge">{children}</div>
}


const UserNeedsBadges = ({userNeedsObj, onSingleStory} : UserNeedsBadgesProps) => {

    if (!userNeedsObj || userNeedsObj == undefined) return <></>

    return <div className="un-badges-wrapper">
        <div className={`un-badges-container ${onSingleStory && "single-story"}`}>
            {
                userNeedsObj?.emotion_driven && <UNBadge>EMO</UNBadge> 
            }
            {
                userNeedsObj?.context_driven && <UNBadge>CON</UNBadge>
            }
            {
                userNeedsObj?.fact_driven && <UNBadge>FAC</UNBadge>
            }
            {
                userNeedsObj?.action_driven && <UNBadge>ACT</UNBadge>
            }
        </div>
    </div>
}

export default UserNeedsBadges;